import { Pagination as MuiPagination, styled } from '@mui/material';

import { getPageCount } from '../../utils';
import { PaginationDisplayedRows } from '../PaginationDisplayedRows';
import { PaginationItem } from '../PaginationItem';
import { paginationClasses } from './theme';

import type { PaginationProps } from './types';

const Pagination = (props: PaginationProps) => {
  const {
    siblingCount = 2,
    count = -1,
    rowsPerPage = -1,
    page = 0,
    onChange,
    renderLabelDisplayedRows,
    hideLabelDisplayRows,
    hasMore,
    ...others
  } = props;

  return (
    <PaginationRoot>
      {!hideLabelDisplayRows && (
        <PaginationDisplayedRows
          page={page}
          count={count}
          rowsPerPage={rowsPerPage}
          hasMore={hasMore}
          renderLabelDisplayedRows={renderLabelDisplayedRows}
        />
      )}
      <MuiPagination
        shape="rounded"
        variant="text"
        count={getPageCount({ count, rowsPerPage })}
        page={page + 1}
        siblingCount={siblingCount}
        onChange={(e, page) => {
          if (onChange) {
            onChange(e, page - 1);
          }
        }}
        renderItem={item => <PaginationItem {...item} />}
        {...others}
      />
    </PaginationRoot>
  );
};

export default Pagination;

const PaginationRoot = styled('div', {
  target: paginationClasses.root,
})`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;
